// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		$('#primary-nav a').click(function () {
			var target = $(this).attr("href");
			$('html, body').animate({scrollTop: $(target).offset().top - $('header').height()}, 1000);

			$('.preview').hide();

			return false;
		}); 

		//filter by tag
		$('.filter a').click(function(e){
			e.preventDefault()
			const blogId = $(this).data('blog'),
				  filter = $(this).data('filter');
			if(blogId!==undefined){
				$(`.c_${blogId} .filter a`).removeClass('active')
				const items = $(`.c_${blogId} .grid__unit`);
				items.each((i,item)=>{
					if(filter=='all')
						$(item).removeClass('hidden')
					else{
						$(item).addClass('hidden')
						if($(item).hasClass(filter))
							$(item).removeClass('hidden')
					}
				})
				$(this).addClass('active');
			}
		});

		//close info
		$('.preview__close').click(function(e){
			e.preventDefault()
			$('.preview').hide();
		});

		//show info
		$('.grid__unit').click(function(e){
			e.preventDefault()
			const 	id 		= $(this).data('id'),
					prevId 	= ($(this).prev().data('id')===undefined)?null:$(this).prev().data('id'),
					nextId 	= ($(this).next().data('id')===undefined)?null:$(this).next().data('id'),
					blogId = $(this).parent().data('blog');

			loadPreviewInfo(id,prevId,nextId,blogId);
		});

		//preview event
		$('.arrow.previous, .arrow.next').click(function(e){
			e.preventDefault()
			let blogId = $(this).data('blog'),
				  id 	 = $(this).data('id');

			
			$(`.c_${blogId} .grid__unit`).filter((i,item)=>{
				if($(item).data('id')==id){
					$(`#preview-${blogId}`).hide();
					$(`#preview-${blogId} .arrow.previous`).data('id','');
					$(`#preview-${blogId} .arrow.next`).data('id','');

					let prevId = ($(item).prev().data('id')===undefined)?null:$(item).prev().data('id');
					let nextId = ($(item).next().data('id')===undefined)?null:$(item).next().data('id');
					
					loadPreviewInfo(id,prevId,nextId,blogId);
				}
			});
			
		});
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
		
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function loadPreviewInfo(id,prevId,nextId,blogId){
	
	$.post( "/ajax/functions.php",
		{
			operation: 'getBlogEntryById',
			id: id
		},
		function(data){
			if(data.result == 'success') {
				
				$(`#preview-${blogId} .preview__title`).html(data.blogEntry.title);
				$(`#preview-${blogId} .preview__subtitle`).html(data.blogEntry.subtitle);
				if(data.blogEntry.button != '') {
					$(`#preview-${blogId} .preview__website-url`).attr('href',data.blogEntry.button);
					$(`#preview-${blogId} .preview__website-url`).show();
				} else {
					$(`#preview-${blogId} .preview__website-url`).hide();
				}
				
				if(blogId == 13371){
					$('.allslide').slick('unslick');
					$(`#preview-${blogId} .preview__img, #preview-${blogId} .allslide`).remove();
					$(`#preview-${blogId}`).append("<div class='allslide'></div>");
					$.each(data.blogEntry.images, (i,image)=>{
						if(image.tag.indexOf("thumbnail")=="-1")
							$(`#preview-${blogId} .allslide`).append('<div><img src="' + image.src + '" style="max-width:none"/></div>');
					})

					setTimeout( ()=>{ $('.allslide').slick({adaptiveHeight: true}) }, 30 );
				}else{ 
					$.each(data.blogEntry.images, (i,image)=>{
						if(image.tag=='portfolio')
							$(`#preview-${blogId} .preview__img`).attr('src',image.src);
					})
				}	
				
				if(prevId){
					$(`#preview-${blogId} .arrow.previous`).data('id',prevId);
					$(`#preview-${blogId} .arrow.previous`).data('blog',blogId);
					$(`#preview-${blogId} .arrow.previous`).show()
				}else
					$(`#preview-${blogId} .arrow.previous`).hide()
				
				if(nextId){
					$(`#preview-${blogId} .arrow.next`).data('id',nextId);
					$(`#preview-${blogId} .arrow.next`).data('blog',blogId);
					$(`#preview-${blogId} .arrow.next`).show();
				}else
					$(`#preview-${blogId} .arrow.next`).hide();

				
				$(`#preview-${blogId}`).show();
			}else{
				console.log(data.errorMsg);
			}
		},
		"json"
	);
} 

function loginMembers(e){
	e.preventDefault();
	var extras = new Object(),formId = "loginForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'loginMembers',
		username: $("#username").val(),
		password: $("#password").val(),
		agree: $("input:radio[name=agree]").is(":checked")
	},
	function(data){
		if(data.result == 'success') {
			localStorage.setItem( "username", data.name );

			extras.page_redirect = '/projects';
			document.location = "/projects";
			if(data.warning==1)
				localStorage.setItem('msg',1);
			//showResult(data, formId, extras);
		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function activeAccount(e){
	e.preventDefault();
    var extras = new Object(),formId = 'activeForm',$processpage = 'ajax/functions.php';;
	extras.dont_hide_form = "1";
    extras.dont_reset_form = "1";

    $("#processing").show();
	$("#btnSubmit").hide();
	
	$('.errorMsg').slideUp();
    $(".errorMsg").html('');

    clearErrors(formId);
    formProcessSetup(formId);
    
    $.post(site_url+$processpage,
        { 
            operation: 'activeAccount', 
            email_reset: $("#email_reset").val(),
            token: $("#token").val(),
            password_reset: $('#password_reset').val(),
            confirm_password : $('#confirm_password').val()
        },function(data){
            if(data.result=='success'){
                //toastr.success('Thank you for your request.');
                $("#email_reset").val('');
                $('#password_reset').val('');
                $('#confirm_password').val('');
                $('#activeForm .errorMsg').slideDown();
				$(".errorMsg").html('Thank you. Your password has been reset. Please save this password for your records.');
				extras.page_redirect = "index.php";
				setTimeout(()=>{
					showResult(data,formId,extras);
				},4000);
            }else{
                showErrors(data,formId,extras);
            }
            $("#processing").hide();
        },
        "json"
    );
}

function processRecovery(e){
	e.preventDefault();
	var extras = new Object(),formId = "forgotForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'processRecovery',
		email_forgot: $("#email_forgot").val()
	},
	function(data){
		if(data.result == 'success') {
			document.querySelector('.loginPopup').classList.remove('open');
		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function showResult(data, formId, extras)
{
	/*extras parameters:
		dont_reset_form = if set will not reset the form
		dont_hide_form = if set will not hide the form
		skip_parent_errors = if set errors will not be placed on the parent elements
		step_content = if set will load up the content  into div
		page_redirect = if set will redirect to the page passed on success
		function_name = if set will call function on form submit success
		use_exact_path = if set will use exact path passed instead of a SITE_ROOT path
		exact_path = path to use for the above option
		dont_scroll_on_error = if set will not scroll to top of page when theres an error
		dont_scroll_on_success = if set will not scroll to top on success
		scrollto = element id to scroll to instead
		clear_errors = if set will clear errors on the form
		dont_hide_buttons = if set will not hide the buttons, use for nested forms.
	*/
	if(extras == undefined) { extras = '' } //check if the extras parameters array exists if not set it so that we dont get errors farther down

	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

	if(extras.dont_hide_buttons != '1')
	{
    	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  		if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
  	}

  	//check if result is being passed the new way
	var result; //will hold the value for our result success | error

	if(data[0]==undefined) result = data.result;
	else result = data[0].result;

  	if(result=="success")
	{
  		if(extras.dont_reset_form != '1') { resetForm(formId); } //if the dont_reset_form is isnt set then reset the form
		if(extras.step_content != undefined) //check if the ajax page parameter is defined
		{
			//alert('load up via ajax: ' + data[1].step_content);
		   	$("#step_content").hide();	//this has to stay the same because this is where the forms are being loaded into
	   		$("#step_content").load(SITE_ROOT+extras.step_content,function(){
	   			_gaq.push(['_trackPageview', extras.step_content]);

	        	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	        	$("#step_content").slideDown();}
	        );
	   		if(extras.dont_scroll_on_success != '1')
	        {
		   		if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
	        }
		}
		else if(extras.page_redirect != undefined) //check if page redirect parameter is passed
		{
			if(extras.use_exact_path =='1')
			{
				document.location = extras.exact_path;
			}
			else
			{
				document.location= extras.page_redirect;
			}
		}
		else if(extras.function_name != undefined)
		{
			eval(extras.function_name)();
		}
		else
		{
			if($('.thankyouMsg').length > 0) $('#'+formId+' .thankyouMsg').slideDown();
			if($('#'+formId).prev(".thankyouMsg").length > 0) $('#'+formId).prev(".thankyouMsg").slideDown();

			if(extras.dont_hide_form != '1')
			{
				if($('#'+formId).length > 0) $("#"+formId).slideUp();
			}
			else
			{
				if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
			}
			if(extras.dont_scroll_on_success != '1')
	        {
				if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
			}
		}
		if(extras.clear_errors == '1')
		{ 	clearErrors(formId);	}
	}
	else
	{
		showErrors(data,formId,extras);
	}
}

function showErrors(data,formId,extras){
	clearErrors(formId);

	var newData = new Object();
	if(data[0]==undefined) newData = data;
	else newData = data[0];
	//loop through the JSON array and display the errors
	$.each(newData, function(key,value) {
		if(key != "result")
		{
			if(extras.add_parent_error != undefined)
			{
				if($('#'+key).parent().hasClass("form-entry")) $('#'+key).parent().addClass("error");
			}
			$('label[for='+key+']').addClass("error");
			$('#'+key).addClass("error");
			if(value!=1) { $("#"+formId+" .errorMsg").html($("#"+formId+" .errorMsg").html()+"<li>"+value+"</li>"); }
		}
	});
	if($("#"+formId+" .errorMsg").html()=="") {
		$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red below</li></ul>");
	} else {
		$("#"+formId+" .errorMsg").html("<ul>"+$("#"+formId+" .errorMsg").html()+"</ul>");
	}
	$("#"+formId+" .errorMsg").slideDown();

	if(extras.dont_scroll_on_error != '1')
	{
		if(extras.scrollto != undefined)
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
        	} else {
        		//$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
        	}
   		}
   		else
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo(0,100);
        	} else {
        		//$.scrollTo(0,800);
        	}
   		}
	}

	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').show();
}


function clearErrors(formId)  //safari bug is here!!
{
	$('input[type="text"],input[type="password"],input[type="radio"],textarea,select').removeClass("error");
	$('#'+formId+' label').each(function(index){
        if(!$(this).hasClass('errorMsg')) $(this).removeClass("error");
    });
}

function resetForm(formId)
{
	//$('[type="text"]').val("");
	$('#'+formId+' textarea').val("");
	$(':input','#'+formId)
	 .not(':button, :submit, :reset, :hidden, :checkbox , :radio')
	 .val('')
	 .removeAttr('checked')
	 .removeAttr('selected');

	clearErrors(formId);
}
function formProcessSetup(formId)
{
	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

    if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
}